export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';

export const updateBreadcrumb = (breadcrumb) => ({
  type: UPDATE_BREADCRUMB,
  payload: breadcrumb,
});